export default __webpack_public_path__ + "static/media/appleMusic.cc39cf43.svg";